import store2 from "store2";

import { dashboard_url } from "../config";
import { initialState as ticketsSearchState } from "../store/search/reducer";
import { customersState } from '../store/customers/reducer';
import requestCreator from '../helpers/axiosWrapper';

class DashboardApi {
  state = {
    isLoggingIn: false
  }
  postponed_exec = null;
  dashboard_url = null;
  token = null;
  storageKey = "dbapi_token"
  storageNotAvailableError = "You need to enable local storage!"

  constructor(dashboard_url) {
    this.dashboard_url = dashboard_url;
  }

  login = async ({ email, password }, caller) => {
    if(this.state.isLoggingIn) return this.postponed_exec = caller;
    
    this.state.isLoggingIn = true;

    const url = this.dashboard_url + "/login";
    const result = await requestCreator('put', url, { email, password });

    this.state.isLoggingIn = false;
    const success = result.data.success;

    if(success) {
      this._setToken(result.data.data.token);
    }

    return {
      success,
      data: result.data.data
    }
  };

  profile = async () => {
    const url = this.dashboard_url + "/me";
    const result = await requestCreator('get', url, null, { headers: {Authorization: `Bearer ${this._getToken()}`} });
    return {
      success: result.data.success,
      data: result.data.data
    }
  }

  updateProfile = async ({ name, email, old_password, new_password }) => {
    const url = this.dashboard_url + "/profile";
    const result = await requestCreator('put', url, { name, email, old_password, new_password }, { headers: {Authorization: `Bearer ${this._getToken()}`} });
    return {
      success: result.data.success,
      data: result.data.data
    }
  }

  deleteAdmin = async (id) => {
    const url = this.dashboard_url + "/admin";
    const result = await requestCreator('delete', url, undefined, { params: { id }, headers: {Authorization: `Bearer ${this._getToken()}`} });
    return {
      success: result.data.success,
      data: result.data.data
    }
  }

  updateAdmin = async (admin, { permissions }) => {
    const url = this.dashboard_url + "/admin";
    const result = await requestCreator('put', url, { id: admin._id, permissions }, { headers: { Authorization: `Bearer ${this._getToken()}` } });
    return {
      success: result.data.success,
      data: result.data.data
    }
  }

  createAdmin = async ({name, email, password, permissions}) => {
    const url = this.dashboard_url + "/admin";
    const result = await requestCreator('post', url, {name, email, password, permissions}, {headers: {Authorization: `Bearer ${this._getToken()}`}});
    return {
      success: result.data.success,
      data: result.data.data
    }
  }

  logout = () => {
    this.token = null;
    localStorage.clear();
  } 

  getAdmins = async () => {
    const url = this.dashboard_url + "/admins";
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator('get', url, undefined, { headers, params: { per_page: 50, page: 1 } })
    return result.data;
  } 

  search = async (
    searchOptions = ticketsSearchState.searchOptions,
    paginationOptions = ticketsSearchState.paginationOptions
  ) => {
    const url = this.dashboard_url + "/search";
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator("post", url, searchOptions, { params: paginationOptions, headers });
    return result.data;
  };

  sendEmail = async (email, ticketID, mailType) => {
    const url = this.dashboard_url + "/search/send-email";
    const result = await requestCreator("post", url, {email, ticketID, mailType} , { headers: {Authorization: `Bearer ${this._getToken()}`} });
    return {
      success: result.data.success
      //ticketData: result.data
    }
  };

  searchRatings = async(
    searchOptions = ticketsSearchState.searchOptions,
    paginationOptions = ticketsSearchState.paginationOptions,
  ) => {
    const url = this.dashboard_url + "/ratings";
    const headers = {Authorization: `Bearer ${this._getToken()}`};
    const result = await requestCreator("post", url, searchOptions, { params: paginationOptions, headers });
    console.log('[RATINGS] - Result:', result.data);
    return result.data;   
  }

  stats = async (searchOptions = ticketsSearchState.searchOptions) => {
    const url = this.dashboard_url + "/stats";
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator("post", url, searchOptions, { headers });
    return result.data;
  };

  chartData = async (searchOptions = ticketsSearchState.searchOptions) => {
    const url = this.dashboard_url + "/chart_data";
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator("post", url, searchOptions, { headers });
    return result.data;
  }

  searchCustomers = async (
    searchOptions = customersState.searchOptions,
    paginationOptions = customersState.paginationOptions
  ) => {
    const url = this.dashboard_url + "/customers/search";
    const headers = { Authorization: `Bearer ${this._getToken()}`};
    const result = await requestCreator("get", url, undefined, { params: {
      ...paginationOptions,
      ...searchOptions,
    }, headers});
    return result.data;
  }

  getCustomerExports = async() => {
        const url = this.dashboard_url + '/customers/extracts';
        const headers = { Authorization: `Bearer ${this._getToken()}` };
        const result = await requestCreator('get', url, undefined, { headers });
        return result.data;
  }

  downloadExport = async (name) => {
      const url = this.dashboard_url + '/customers/extracts/' + name;
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
  }

  getCustomerExportProgress = async () => {
        const url = this.dashboard_url + '/customers/extracts/progress';
        const headers = { Authorization: `Bearer ${this._getToken()}` };
        const result = await requestCreator('get', url, undefined, { headers });
        return result.data;
  }

  deleteCustomerExport = async(name) => {
      const url = this.dashboard_url + '/customers/extracts/' + name;
      const headers = { Authorization: `Bearer ${this._getToken()}` };
      const result = await requestCreator('delete', url, undefined, { headers });
      return result.data;
  }

  exportCustomers = async() => {
      const url = this.dashboard_url + '/customers/extracts';
      const headers = { Authorization: `Bearer ${this._getToken()}` };
      const result = await requestCreator('post', url, undefined, { headers });
      return result.data;
  }

  forgotPassword = async (email) => {
    const url = this.dashboard_url + "/user/forgot-password";
    const result = await requestCreator("put", url, { email });
    return result.data;
  }

  resetPassword = async (password, token) => {
    const url = this.dashboard_url + "/user/reset-password";
    const result = await requestCreator("put", url, { resetToken: token, password });
    return result.data;
  }

  getTranslations = async () => {
    const url = this.dashboard_url + '/translations';
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator('get', url, null, { headers });
    return result.data;
  }

  updateTranslations = async (translations) => {
    const url = this.dashboard_url + '/translations';
    const headers = { Authorization: `Bearer ${this._getToken()}` };
    const result = await requestCreator('put', url, { translations }, { headers })
    return result.data;
  }

  isLoggedIn = () => {
    try {
      return localStorage.getItem(this.storageKey, this.token);
    } catch (error) {
      alert(this.storageNotAvailableError);
      return this.token;
    }
  }

  getUserPermissions = () => {
    let user = store2.get('user');
    return user? user.permissions: [];
  }

  /**
   * @returns {string}
   */
  _getToken = () => {
    try {
      // return localstorage token or default token string in memory
      return localStorage.getItem(this.storageKey, this.token);
    } catch (error) {
      alert(this.storageNotAvailableError);
      // return in memory token if storage is not available
      return this.token;
    }
  };

  _setToken = token => {
    this.token = token;
    try {
      localStorage.setItem(this.storageKey, token);
    } catch (error) {
      alert(this.storageNotAvailableError);
    }
  };
}

export default new DashboardApi(dashboard_url);
